import { MasterdataEntityRegistry } from '@softapps/core/masterdata';
import { SOFTLINE_AI_AGENT_MENTION_ENTITIES } from '../ai-agent.tokens';
import { AiAgentClientTool } from '../types/client-tool.type';

/** Tells the model which masterdata `resolve_masterdata` accepts, with the
 *  domain wording the user sees. */
export const listMasterdataEntitiesTool: AiAgentClientTool<Record<string, never>> = {
  name: 'list_masterdata_entities',
  description:
    'Listet die Stammdaten-Typen auf, die mit resolve_masterdata aufgelöst werden können.',
  parameters: { type: 'object', properties: {} },
  async execute(_args, injector) {
    const allowed = new Set(injector.get(SOFTLINE_AI_AGENT_MENTION_ENTITIES));
    return {
      entities: injector
        .get(MasterdataEntityRegistry)
        .all()
        .filter((d) => allowed.has(d.name))
        .map((d) => ({ name: d.name, label: d.label })),
    };
  },
};
